import type { FaireProductEntity } from "../../entity_types/product";

export const p_tx5bh7djqz: FaireProductEntity = {
  token: "p_tx5bh7djqz",
  type: "product",
  name: "A-623-40 Intricate Celtic Golden Knot Ring",
  brandToken: "b_pntx8vkece",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/db7d9cf7e74c4f2c68ff5fe92af02f7e87a74c141c58c0214a62dfd6656d3680.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcac9337a3001cc22ed81ef4504748491082f8db234e78d144dbec3155b09a85.jpeg",
  ],
  priceDollars: 5.99,
  description:
    "Product code: A-623\n\nFeatures and Specifications\n\nAll rings are beautifully sculpted and are well designed\n material\n\n316 steel, also known as marine grade stainless steel, is a chromium, nickel, molybdenum steel alloy that has relatively good strength and corrosion resistance. 316L is the low-carbon version of 316 stainless steel. 316L surgical steel is a common choice for biomedical implants, as well as body modification piercings and implants.\nHand polished and shiny\n Measure\n\nNot adjustable\nFrom 7 to 14, for details, see the size chart",
  tags: [],
  msrpDollars: 11.97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:36.468Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
